import type { ReactNode } from 'react';

/** One label-and-value row of a ticket's details, the same on both panels. */
export function TicketFact({ label, value }: { label: string; value: ReactNode }) {
  return (
    <div className="flex items-baseline justify-between gap-3 text-xs py-1.5 border-b border-line/40 last:border-b-0">
      <dt className="text-ink-3 font-medium">{label}</dt>
      <dd className="text-right text-ink font-semibold">{value}</dd>
    </div>
  );
}
